import { render, staticRenderFns } from "./PositionsSubscribe.vue?vue&type=template&id=2a2c34bd&scoped=true&"
import script from "./PositionsSubscribe.vue?vue&type=script&lang=ts&"
export * from "./PositionsSubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./PositionsSubscribe.vue?vue&type=style&index=0&id=2a2c34bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c34bd",
  null
  
)

export default component.exports